export const APP_LANGUAGES = [{value: 'en', label: 'English'}, {value: 'de', label: 'Deutsch'}, {value: 'es', label: 'Español'}];
const STORAGE_KEY = 'luckynote.product-language.v1';
export function createLanguagePreference({i18n, storage, getDeviceLanguage = () => "en"}) {
    let preference = 'en';
    const supported = value => value === 'system' || APP_LANGUAGES.some(item => item.value === value);
    const resolve = value => {
        const code = value === 'system' ? String(getDeviceLanguage() || '').split(/[-_]/)[0].toLowerCase() : value;
        return APP_LANGUAGES.some(item => item.value === code) ? code : 'en';
    };
    let generation = 0;
    let restoration;
    let queue = Promise.resolve();
    const restore = () => {
        if (!restoration) {
            const requestedGeneration = generation;
            restoration = (async () => {
            try {
                const saved = await storage.getItem(STORAGE_KEY);
                if (generation === requestedGeneration && supported(saved)) {preference = saved; await i18n.changeLanguage(resolve(saved));}
            } catch (_) { /* Storage failure retains bundled default. */ }
        })().finally(() => {restoration = null;});
        }
        return restoration;
    };
    const select = language => {
        if (!supported(language)) return Promise.reject(new Error('Unsupported product language'));
        generation += 1;
        queue = queue.catch(() => {}).then(async () => {
            preference = language;
            await i18n.changeLanguage(resolve(language));
            try {await storage.setItem(STORAGE_KEY, language);return {saved: true};}
            catch (_) {return {saved: false};}
        });
        return queue;
    };
    return {restore, select, getPreference: () => preference};
}
